export class QuarterlyPipelineColumns {
    quarter;
    category;
    type;
    properties;
    totalPrice;
    totalGrossFee;
    split;
    striveGrossFee;

    constructor({quarter, category, type, data}) {
        let propertiesKey = `TOTAL_QUARTER_PROPERTIES`;
        let priceKey = `TOTAL_QUARTER_PRICE`;
        let feeKey = `TOTAL_QUARTER_GROSS_FEE`;
        let listSplitKey = `LIST_QUARTER_SPLIT`;
        let buySplitKey = `BUY_QUARTER_SPLIT`;
        let refferalListSplitKey = `LIST_QUARTER_SPLIT_RA`;
        let refferalBuySplitKey = `BUY_QUARTER_SPLIT_RA`;

        if (category || type) {
            propertiesKey = type ? `TOTAL_${category.toUpperCase()}_${type.toUpperCase()}_PROPERTIES` : `TOTAL_${category.toUpperCase()}_PROPERTIES`;
            priceKey = type ? `TOTAL_${category.toUpperCase()}_${type.toUpperCase()}_PRICE` : `TOTAL_${category.toUpperCase()}_PRICE`;
            feeKey = type ? `TOTAL_${category.toUpperCase()}_${type.toUpperCase()}_GROSS_FEE` : `TOTAL_${category.toUpperCase()}_GROSS_FEE`;
            listSplitKey = type ? `LIST_${category.toUpperCase()}_${type.toUpperCase()}_SPLIT` : `LIST_${category.toUpperCase()}_SPLIT`;
            buySplitKey = type ? `BUY_${category.toUpperCase()}_${type.toUpperCase()}_SPLIT` : `BUY_${category.toUpperCase()}_SPLIT`;
            refferalListSplitKey = type ? `LIST_${category.toUpperCase()}_${type.toUpperCase()}_SPLIT_RA` : `LIST_TOTAL_${category.toUpperCase()}_SPLIT_RA`;
            refferalBuySplitKey = type ? `BUY_${category.toUpperCase()}_${type.toUpperCase()}_SPLIT_RA` : `BUY_TOTAL_${category.toUpperCase()}_SPLIT_RA`;
        }

        switch (type) {
            case 'STNL':
                this.type = 'Single-Tenant';
                this.category = null;
                this.quarter = null;
                break;
            case 'MT':
                this.type = 'Multi-Tenant';
                this.category = null;
                this.quarter = null;
                break;
        }
        if (category && !type) {
            this.quarter = null;
            this.category = category;
        }
        if (!category && !type) {
            this.quarter = quarter;
            this.category = null;
            this.type = null;
        }

        this.properties = data[propertiesKey] ? parseInt(data[propertiesKey]) : 0;
        this.totalPrice = data[priceKey] ? parseFloat(data[priceKey]) : 0;
        this.totalGrossFee = data[feeKey]? parseFloat(data[feeKey]) : 0;
        const listSplit = data[listSplitKey] ? parseFloat(data[listSplitKey]) : 0;
        const buySplit = data[buySplitKey] ? parseFloat(data[buySplitKey]) : 0;
        const listRefSplit = data[refferalListSplitKey] ? parseFloat(data[refferalListSplitKey]) : 0;
        const buyRefSplit = data[refferalBuySplitKey] ? parseFloat(data[refferalBuySplitKey]) : 0;
        this.split = listSplit + buySplit + listRefSplit + buyRefSplit;
        this.striveGrossFee = this.totalGrossFee - this.split;
        if (type || category) {
            this.collapsed = !!(type || category);
        } else {
            this.childrenCollapsed = true;
        }
    }
}